import React, { useEffect } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getAllFavoriteItems } from '@/redux/modules/favorites/favorites.selectors';
import { getItemSummariesForCatalog } from '@/redux/modules/item/summary/itemSummary.selectors';

import { useFindLiveItemIndex } from './useFindLiveItemIndex';

type Props = {
    catalogId: number;
    itemId: number;
};

type LotsRelativeFavoritesPositionProps = {
    [itemId: number]: number;
};

export const useCalculatedRelativeFavoritesPosition = ({ catalogId, itemId }: Props) => {
    const favoriteItems = useAppSelector((state) => getAllFavoriteItems(state));
    const items = useAppSelector((state) => getItemSummariesForCatalog(state, catalogId));
    const liveItemIndex = useFindLiveItemIndex({ catalogId, itemId });

    const [favoriteItemsLength, setFavoriteItemsLength] = React.useState(0);
    const [indexDifference, setIndexDifference] = React.useState(0);
    const [lotRelativeFavoritePositionObject, setLotRelativeFavoritePositionObject] =
        React.useState<LotsRelativeFavoritesPositionProps>({});

    useEffect(() => {
        let tempFavoritesObject: LotsRelativeFavoritesPositionProps = {};

        if (
            favoriteItems.length ||
            favoriteItemsLength !== favoriteItems.length ||
            (favoriteItems.length && indexDifference !== liveItemIndex)
        ) {
            favoriteItems.forEach((favoriteItemId) => {
                const favoriteItemIndex = items.findIndex((item) => item.itemId === favoriteItemId);
                if (favoriteItemIndex > liveItemIndex) {
                    tempFavoritesObject[favoriteItemId] = favoriteItemIndex - liveItemIndex;
                }
            });

            setLotRelativeFavoritePositionObject(tempFavoritesObject);
            setFavoriteItemsLength(favoriteItems.length);
            setIndexDifference(liveItemIndex);
        }
    }, [favoriteItems, liveItemIndex, items, favoriteItemsLength, indexDifference]);

    return lotRelativeFavoritePositionObject;
};
